function Story() {
  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">Story Page</h1>
    </div>
  );
}

export default Story;